import { configureStore } from "@reduxjs/toolkit";
// import thunk from 'redux-thunk'
// import { TypedUseSelectorHook, useSelector as rawUseSelector } from "react-redux";
// import anvSlice from "./anv-slice";
import authReducer from './authSlice';
import pageContentReducer from './pageContentSlice';
import sysSlice from "./sys-slice";
import websiteSlice from './websiteSlice';

const store = configureStore({
    reducer: {
        pageContent: pageContentReducer,
        website: websiteSlice,
        auth: authReducer,
        sys: sysSlice.reducer,
    },
    // middleware 
});

export default store;

// export type RootState = ReturnType<typeof store.dispatch> // Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState> // Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;